module.exports = __webpack_public_path__ + "img/info-con2.25eec23d.png";